/**
 * Workspace settings Types
 * 
 * Type definitions for workspace configuration and settings
 */

export interface ShareLink {
  id: string
  name: string
  token: string
  createdAt: string
  expiresAt: string | null
  permissions: 'view' | 'edit'
  isActive: boolean
  views: number
}

export interface IPFilter {
  id: string
  ip: string
  label?: string
  createdAt: string
  isActive: boolean
}

export interface WorkspaceSettings {
  // Timezone settings
  timezone: string
  useBrowserTimezone: boolean
  
  // Hash fragment settings
  hashFragTracking: boolean
  spaMode: boolean
  stripHash: boolean
  
  // Share link settings
  publicDashboard: boolean
  sharePassword?: string
  shareLinks: ShareLink[]
  
  // IP filtering settings
  ipFilteringEnabled: boolean
  ipFilters: IPFilter[]
}

export const defaultWorkspaceSettings: WorkspaceSettings = {
  // Timezone - default to browser timezone
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  useBrowserTimezone: true,
  
  // Hash fragments - disabled by default
  hashFragTracking: false,
  spaMode: false,
  stripHash: true,
  
  // Sharing - disabled by default
  publicDashboard: false,
  sharePassword: undefined,
  shareLinks: [],
  
  // IP filtering - disabled by default
  ipFilteringEnabled: false,
  ipFilters: [],
}


